






















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import TitleContainer from "@/components/common/TitleContainer.vue";
import { MetaInfo } from "vue-meta/types/vue-meta";
import { pageSEO } from "@/utils/seo";
import seoDefault from "@/utils/seo-default";
import MainButton from "@/main-components/common/MainButton.vue";
import Input from "@/main-components/common/Input.vue";
import { axios } from "@/utils/axios";
import { SuggestedJob } from "@/main-components/career-path/suggested-job.type";
import SuggestedJobView from "@/main-components/career-path/SuggestedJobView.vue";
import ModalUnlockCareerPath from "@/main-components/career-path/ModalUnlockCareerPath.vue";
import LoadingBox from "@/components/common/LoadingBox.vue";

type Subject = {
  id: number;
  name: string;
  selected: boolean;
};

type WorkEnv = {
  id: number;
  name: string;
  description: string;
  selected: boolean;
};

@Component({
  components: {
    TitleContainer,
    MainButton,
    Input,
    SuggestedJobView,
    ModalUnlockCareerPath,
    LoadingBox,
  },
  metaInfo(this: CareerPath): MetaInfo {
    return {
      title: pageSEO.title.careerPath,
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: pageSEO.canonical.careerPath,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.careerPath,
          description: pageSEO.description.careerPath,
        }),
      ],
    };
  },
})
export default class CareerPath extends Vue {
  subjects: Subject[] = [
    { id: 1, name: "Sejarah", selected: true },
    { id: 2, name: "Science", selected: false },
    { id: 3, name: "Sains Komputer", selected: false },
    { id: 4, name: "Reka Cipta", selected: false },
    { id: 5, name: "Reka Bentuk dan Teknologi", selected: false },
    { id: 6, name: "Prinsip Perakaunan", selected: false },
    { id: 7, name: "Physics", selected: false },
    { id: 8, name: "Perniagaan", selected: false },
    { id: 9, name: "Pendidikan Seni Visual", selected: false },
    { id: 10, name: "Pendidikan Moral", selected: false },
    { id: 11, name: "Pendidikan Jasmani dan Kesihatan", selected: false },
    { id: 12, name: "Pendidikan Islam", selected: false },
    { id: 13, name: "Mathematics", selected: false },
    { id: 14, name: "Geografi", selected: false },
    { id: 15, name: "English", selected: false },
    { id: 16, name: "Ekonomi", selected: false },
    { id: 17, name: "Chemistry", selected: false },
    { id: 18, name: "Biology", selected: false },
    { id: 19, name: "Bahasa Melayu", selected: false },
    { id: 21, name: "Additional Mathematics", selected: false },
  ];

  workEnvs: WorkEnv[] = [
    {
      id: 1,
      name: "Kerja Dalam Group",
      description: "Best bila dapat kerja sama-sama dengan orang lain.",
      selected: true,
    },
    {
      id: 2,
      name: "Kerja Sendiri",
      description: "Lagi suka kerja solo, senang nak fokus.",
      selected: false,
    },
    {
      id: 3,
      name: "Tempat Sibuk dan Happening",
      description: "Suka suasana busy, rasa macam banyak benda nak explore.",
      selected: false,
    },
    {
      id: 4,
      name: "Tolong Orang Terus",
      description: "Rasa puas bila boleh bantu orang face-to-face.",
      selected: false,
    },
    {
      id: 5,
      name: "Buat Benda Kreatif",
      description: "Best bila boleh cipta atau bina sesuatu dengan tangan sendiri.",
      selected: false,
    },
  ];

  interestInput = "";

  careerPathUuid = "";
  suggestedJobs: SuggestedJob[] = [];
  isLoading = false;
  isLoadingExistingCareerPath = false;
  hasExistingCareerPath = false;

  firstClickSubject = false;
  firstClickEnv = false;
  firstWriteInterest = false;

  interestPlaceholder = `
  Contoh:
   - Saya suka melukis kartun
   - Saya pandai edit video
   - Saya minat masak dan cuba resepi baru
   - Saya minat coding
  `;

  get existingCareerPathUuid() {
    return (
      this.$route.query &&
      this.$route.query["result"] &&
      (this.$route.query["result"] as string)
    );
  }

  get selectedSubjects() {
    return this.subjects.filter((subject) => subject.selected);
  }

  get selectedWorkEnvs() {
    return this.workEnvs.filter((workEnv) => workEnv.selected);
  }

  created() {
    if (this.existingCareerPathUuid) {
      this.getExistingSuggestedJob();
    } else {
      this.$sendMpEvent({
        event: this.$mp_value.CareerPath_view,
      });
    }
  }

  selectSubject(selectedSubject: Subject) {
    if (this.isLoading) return;

    if (!this.firstClickSubject) {
      this.$sendMpEvent({
        event: this.$mp_value.CareerPath_subject_click,
      });

      this.firstClickSubject = true;
    }

    if (this.selectedSubjects.length < 3) {
      selectedSubject.selected = true;
    } else {
      const prevSelected = this.subjects.find((subject) => subject.selected);
      if (prevSelected) {
        prevSelected.selected = false;
      }
      selectedSubject.selected = true;
    }
  }

  selectWorkEnv(selectedWorkEnv: WorkEnv) {
    if (this.isLoading) return;

    if (!this.firstClickEnv) {
      this.$sendMpEvent({
        event: this.$mp_value.CareerPath_environment_click,
      });

      this.firstClickEnv = true;
    }

    this.workEnvs.forEach((workEnv) => {
      workEnv.selected = false;
    });
    selectedWorkEnv.selected = true;
  }

  @Watch("interestInput")
  onInterestInputChange() {
    if (!this.firstWriteInterest && this.interestInput) {
      this.$sendMpEvent({
        event: this.$mp_value.CareerPath_interest_write,
      });
      this.firstWriteInterest = true;
    }
  }

  async getSuggestedJobs() {
    if (this.isLoading) return;
    this.isLoading = true;

    this.$sendMpEvent({
      event: this.$mp_value.CareerPath_submit,
    });

    let noTrial = 5;

    while (
      noTrial > 0 &&
      (!this.suggestedJobs.length ||
        (this.suggestedJobs.length && !this.suggestedJobs[0].samples.length))
    ) {
      this.careerPathUuid = "";
      this.suggestedJobs = [];
      await this.getSuggestedJob();
      noTrial -= 1;
    }

    this.isLoading = false;
  }

  async getSuggestedJob() {
    try {
      const { data } = await axios.post(`/add-on/career-path`, {
        subjects: this.selectedSubjects.map((selectedSubject) => selectedSubject.name),
        skillInterest: this.interestInput,
        workEnv: this.selectedWorkEnvs[0].name,
      });

      if (data) {
        this.careerPathUuid = data.uuid;
        this.suggestedJobs = data.finalSuggestedJobs;
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: error,
      });
    }
  }

  async getExistingSuggestedJob() {
    this.isLoadingExistingCareerPath = true;
    try {
      const { data } = await axios.get(
        `/add-on/career-path/${this.existingCareerPathUuid}`
      );

      if (data) {
        this.careerPathUuid = this.existingCareerPathUuid;
        this.suggestedJobs = data;
        this.hasExistingCareerPath = true;
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: (error as any).message,
      });

      this.careerPathUuid = "";
      this.suggestedJobs = [];
      this.hasExistingCareerPath = false;
    }
    this.isLoadingExistingCareerPath = false;
  }

  openUnlockCareerModal(isCareerPath: boolean) {
    (this.$refs.ModalUnlockCareerPath as any).toggleUnlockCareerModal(true, isCareerPath);
  }
}
